<template>
    <div class="render-post hide-scrollbar render-post-telegram">

       
        <div class="post-header">
            <div></div>
            <p class="name">{{ pageName && picturePages.length == 1 ? pageName : 'Groupe' }}</p>
            <div class="img-pages">

                <template v-for="(picturePage,index) in picturePages.slice(0,picturePages.length == 4 ? 4 : 3)">
                    <Tooltip :key="index" :active="picturePage.iconEdited" :text="'Voir les modifications apportées'" position="right" :classCustom="`page ${picturePage.iconEdited ? 'iconEdited' : ''}`" @click="()=>{$emit('clickPage', picturePage.id)}">
                        <img :src="picturePage && picturePage.avatar ? picturePage.avatar : 'img/avatar.jpg'" alt="">
                    </Tooltip>
                </template>
              
                <div class="page count" v-if="picturePages.length > 4">
                    +{{ picturePages.length - 3 }}
                </div>
            </div>
        </div>
        <div class="conversation hide-scrollbar">
            <div class="date">
                <p>{{ datePost ? formatDatePost : 'A l\'instant' }}</p>
            </div>
            <div class="post-content" v-if="text || snippet.link">
                <div class="post-text">
                    <p v-html="textTranslateMentionAndHastag"></p>
                </div>

                <div class="snippet" v-if="snippet.link">
                    <SnippetNetwork :link="snippet.link"></SnippetNetwork>
                </div>
          
       
            </div>


            <div class="post-content" v-if="comment">
                <div class="post-text">
                    <p v-html="commentTranslateMentionAndHastag"></p>
                </div>
            </div>
        </div>
       
    </div>
</template>

<script>
    import { Carousel, Slide } from 'vue-carousel';
    import SnippetNetwork from '../SnippetNetwork.vue'
    import Tooltip from '../../tooltip/tooltipInit.vue'

    export default {
        components: {
            Carousel,
            Slide,
            SnippetNetwork,
            Tooltip
        },

        props: {
            picturePages: {
                type: Array,
                default: () => [] 
            },
            pageName : {
                type: String,
                default: ''
            },
            datePost: {
                default: 1315349759920 
            },
            medias: {
                type: Array,
                default: () => [] 
            },
            text : {
                type: String,
                default: ''
            },
            comment : {
                type: String,
                default: ''
            },
            snippet: {
                type: Object,
                default: ()=>({
                    link : "",
                    title: "",
                    description: "",
                    domaine:"",
                    imageUrl:""
                })
            },


            mentions: {
                type: Object,
                default: ()=>({})
            }
           
        },

        computed: {
            formatDatePost: function(){
                if(this.datePost == false) return '';
                let dateNow = new Date()
                let dateFuture = new Date(this.datePost)

                const addHours = (dateString) => (`${dateString} à ${dateFuture.getHours()}h${dateFuture.getMinutes().toString().padStart(2, '0')}`)
        
                if (dateFuture.getFullYear() === dateNow.getFullYear()) {
                    if (Math.abs(Math.ceil(Math.abs(dateFuture-dateNow) / (1000 * 60 * 60 * 24))) < 7) {
                        if (dateFuture.getDay() === dateNow.getDay()) return addHours("Aujourd'hui")
                        if (dateFuture.getDay() === dateNow.getDay()+1) return addHours("Demain")
                        if (dateFuture.getDay() === dateNow.getDay()-1) return addHours("Hier")
                        return addHours(dateFuture.toLocaleDateString(undefined, { weekday: 'long' }));
                    }
                
                    if(dateFuture.getMonth() === dateNow.getMonth()) return addHours(dateFuture.toLocaleDateString(undefined, { weekday: 'long', day: 'numeric'}));

                    return addHours(dateFuture.toLocaleDateString(undefined, { weekday: 'long', day: 'numeric', month: 'numeric' }));
                }
                return addHours(dateFuture.toLocaleDateString(undefined, { day: 'numeric', month: 'numeric', year: 'numeric' }));
            },

            textTranslateMentionAndHastag() {
                //return this.text
                return this.text.replace(/#\w+/g, '<b class="hashtag">$&</b>').replace(/@(\d{13})/g, (match, id) => {

                    const mention = this.mentions[id];
                    if (mention) {
                        return mention.mention && mention.mention.telegram ? `<span class="mention">@${mention.mention.telegram.id || mention.mention.telegram.name}</span>` : mention.textDefault;
                    }
                    return match;
                }).replace(/\n/g, '<br>');
              
            },

            commentTranslateMentionAndHastag() {
                return this.comment.replace(/#\w+/g, '<b class="hashtag">$&</b>').replace(/@(\d{13})/g, (match, id) => {
                    const mention = this.mentions[id];
                    if (mention) {
                        return mention.mention && mention.mention.telegram ? `<span class="mention">@${mention.mention.telegram.id || mention.mention.telegram.name}</span>` : mention.textDefault;
                    }
                    return match;
                }).replace(/\n/g, '<br>');
            }
          
        },
    }
</script>
